(function () {
  // Reset all sticky buttons (bfcache / section reloads / errors, etc.)
  function resetStickyButtons() {
    document.querySelectorAll('.sticky-atc__btn').forEach(function (btn) {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    });
  }

  resetStickyButtons();

  window.addEventListener('pageshow', resetStickyButtons);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') resetStickyButtons();
  });
  document.addEventListener('shopify:section:load', resetStickyButtons);
  document.addEventListener('shopify:section:unload', resetStickyButtons);
  document.addEventListener('shopify:section:select', resetStickyButtons);
  document.addEventListener('shopify:section:deselect', resetStickyButtons);

  // Helper: from a selector, pick the first match that is NOT inside the cart drawer
  function pickOutsideCartDrawer(selector) {
    var all = Array.from(document.querySelectorAll(selector));
    return (
      all.find(function (el) {
        return !el.closest('cart-drawer-component');
      }) || null
    );
  }

  function init(config) {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;

    var variantInput = bar.querySelector('[data-sticky-atc-variant]');
    var qtyInput = bar.querySelector('[data-sticky-atc-qty]');
    var btn = bar.querySelector('.sticky-atc__btn');

    // MAIN PRODUCT ELEMENTS (outside cart drawer)
    var mainForm = pickOutsideCartDrawer(config.productFormSelector);
    var mainSubmit = pickOutsideCartDrawer(config.productSubmitSelector);
    var mainVariant = pickOutsideCartDrawer(config.variantInputSelector);

    // If we can't find a main form+button at all, just don't do anything
    if (!mainForm || !mainSubmit) {
      bar.hidden = true;
      bar.classList.remove('is-visible');
      return;
    }

    // Sync variant id
    if (mainVariant && variantInput) {
      variantInput.value = mainVariant.value;

      document.addEventListener('change', function (e) {
        if (
          e.target &&
          e.target.matches(config.variantInputSelector) &&
          !e.target.closest('cart-drawer-component')
        ) {
          variantInput.value = e.target.value;
        }
      });
    }

    // Sync quantity
    document.addEventListener('change', function (e) {
      if (
        e.target &&
        e.target.closest(config.productFormSelector) &&
        !e.target.closest('cart-drawer-component') &&
        e.target.name === 'quantity' &&
        qtyInput
      ) {
        qtyInput.value = e.target.value;
      }
    });

    // VISIBILITY: IntersectionObserver on main product ATC
    function hideBar() {
      bar.classList.remove('is-visible');
      bar.hidden = true;
    }

    function showBar() {
      bar.hidden = false;
      bar.classList.add('is-visible');
    }

    // Start hidden
    hideBar();

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // Main ATC visible in viewport => hide sticky
            hideBar();
          } else {
            // Main ATC out of viewport => show sticky
            showBar();
          }
        });
      },
      {
        root: null,
        threshold: 0,
        // you can tweak margin if header overlaps:
        // rootMargin: "0px 0px -60px 0px"
      }
    );

    io.observe(mainSubmit);

    // ADD TO CART: ajax + fallback
    async function ajaxAdd(id, qty) {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id: id, quantity: qty }),
      });

      if (!res.ok) throw new Error('Add to cart failed');
      window.location.assign('/cart');
    }

    function fallbackPost(id, qty) {
      var f = document.createElement('form');
      f.method = 'POST';
      f.action = '/cart/add';
      f.innerHTML =
        '<input type="hidden" name="id" value="' +
        id +
        '"><input type="hidden" name="quantity" value="' +
        qty +
        '">';
      document.body.appendChild(f);
      f.submit();
      setTimeout(function () {
        window.location.assign('/cart');
      }, 600);
    }

    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.classList.contains('is-loading')) return;

        var id =
          (variantInput && variantInput.value) ||
          (mainVariant && mainVariant.value);
        if (!id) return;

        var qty = 1;
        var mainQty = mainForm.querySelector('[name="quantity"]');
        if (qtyInput && qtyInput.value) {
          qty = parseInt(qtyInput.value, 10) || 1;
        } else if (mainQty && mainQty.value) {
          qty = parseInt(mainQty.value, 10) || 1;
        }

        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;

        ajaxAdd(id, qty).catch(function () {
          try {
            fallbackPost(id, qty);
          } catch (err) {
            resetStickyButtons();
          }
        });
      });
    }
  }

  (window.__stickyATC__ || []).forEach(init);
  window.__stickyATC__ = { push: init };
})();
